// TODO this is related to practitioners as providers
// this is a bit confusing, as providers can also refer to
// authentication providers. TODO rename to PractitionerProvider
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import { useFirebase } from './FirebaseContext';
import { useAuth } from './AuthContext';
import { ProviderData } from '../types/firebase';

interface ProviderContextType {
    hasProvider: boolean | null;
    providerData: ProviderData | null;
    loading: boolean;
}

const ProviderContext = createContext<ProviderContextType>({
    hasProvider: null,
    providerData: null,
    loading: true
});

export const ProviderProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { currentUser } = useAuth();
    const {app} = useFirebase();
    const [hasProvider, setHasProvider] = useState<boolean | null>(null);
    const [providerData, setProviderData] = useState<ProviderData | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkProviderStatus = async () => {
            if (!currentUser) {
                setHasProvider(false);
                setProviderData(null);
                setLoading(false);
                return;
            }

            const db = getFirestore(app);
            const providersRef = collection(db, 'providers');
            const q = query(providersRef, where('owner_id', '==', currentUser.uid));
            
            try {
                const querySnapshot = await getDocs(q);
                setHasProvider(!querySnapshot.empty);
                if (!querySnapshot.empty) {
                    const data = querySnapshot.docs[0].data();
                    setProviderData(data as ProviderData);
                }
            } catch (error) {
                setHasProvider(null);
            } finally {
                setLoading(false);
            }
        };

        checkProviderStatus();
    }, [currentUser, app]);

    return (
        <ProviderContext.Provider value={{ hasProvider, providerData, loading }}>
            {children}
        </ProviderContext.Provider>
    );
};

export const useProvider = () => useContext(ProviderContext); 